/** Faturalar V2 — sade operasyon teması */

export const iv = {
  bg: '#f4f6f9',
  surface: '#ffffff',
  border: '#e5eaf0',
  borderStrong: '#d0d7e2',
  text: '#0f172a',
  textMuted: '#64748b',
  textFaint: '#94a3b8',
  primary: '#0f766e',
  primaryHover: '#0d9488',
  primarySoft: 'rgba(15, 118, 110, 0.08)',
  danger: '#dc2626',
  dangerSoft: 'rgba(220, 38, 38, 0.08)',
  warning: '#d97706',
  warningSoft: 'rgba(217, 119, 6, 0.1)',
  info: '#2563eb',
  infoSoft: 'rgba(37, 99, 235, 0.08)',
  success: '#059669',
  successSoft: 'rgba(5, 150, 105, 0.1)',
  radius: '10px',
  sidebarW: 220,
  sidebarCollapsedW: 64,
  headerH: 56
};

export const ivSurfaceSx = {
  bgcolor: iv.surface,
  border: `1px solid ${iv.border}`,
  borderRadius: iv.radius,
  boxShadow: 'none'
};

export const ivKpiCardSx = (accent) => ({
  ...ivSurfaceSx,
  p: 1.75,
  cursor: 'pointer',
  transition: 'border-color 0.15s ease, background 0.15s ease',
  borderLeft: `3px solid ${accent}`,
  '&:hover': {
    borderColor: iv.borderStrong,
    bgcolor: '#fafbfc'
  }
});

export const ivSectionTitleSx = {
  fontSize: 11,
  fontWeight: 700,
  color: iv.textMuted,
  letterSpacing: '0.06em',
  textTransform: 'uppercase'
};
